import React from 'react'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'

import { CampaignRewardsResultsPage } from './CampaignRewardsResultsPage'
import luckyDrawResultsColumns from './luckyDrawResultsColumns'

interface OuterProps {
  data: MarketingCampaignDetailDto
}

export const CampaignLuckyDrawDetailsResultsPage: React.FC<OuterProps> = ({ data }) => {
  return <CampaignRewardsResultsPage data={data} columns={luckyDrawResultsColumns} />
}

export default CampaignLuckyDrawDetailsResultsPage
